import CompaignItem from './CompaignItem';

export default CompaignItem;
